'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _browserVendorPrefix = require('browser-vendor-prefix');

var _style = require('../style');

var _reactRedux = require('react-redux');

var _panelsUi = require('panels-ui');

var _widgetsDottedStat = require('../widgets/dotted-stat');

var _widgetsDottedStat2 = _interopRequireDefault(_widgetsDottedStat);

var _groupGetGroupId = require('../group/get-group-id');

var _groupGetGroupId2 = _interopRequireDefault(_groupGetGroupId);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsSponsor = require('../widgets/sponsor');

var _widgetsSponsor2 = _interopRequireDefault(_widgetsSponsor);

var _widgetsStat = require('../widgets/stat');

var _widgetsStat2 = _interopRequireDefault(_widgetsStat);

var PlayerCard = function PlayerCard(props) {
  var titlesText = {
    0: 'Ningún título en ' + props.tournament.name,
    1: '1 título en ' + props.tournament.name,
    many: 'títulos en ' + props.tournament.name
  };

  var tripleCrownTitlesText = {
    0: 'Ningún título de la Triple Corona',
    1: '1 título de la Triple Corona',
    many: 'títulos de la Triple Corona'
  };

  var handicapStyle = _extends({}, style.stat, {
    marginLeft: 45
  });

  return _react2['default'].createElement(
    'div',
    { style: style.player },
    _react2['default'].createElement(
      'div',
      { style: style.playerHeading },
      _react2['default'].createElement(
        'span',
        { style: style.playerNumber },
        props.player.number
      ),
      _react2['default'].createElement(
        'span',
        { style: style.playerName },
        props.player.name
      )
    ),
    _react2['default'].createElement(
      'div',
      { style: style.playerContent },
      _react2['default'].createElement('img', { src: props.player.photo, alt: props.player.name, style: style.playerPhoto }),
      _react2['default'].createElement(_widgetsStat2['default'], { number: props.player.handicap, text: 'Handicap', style: handicapStyle })
    ),
    _react2['default'].createElement(_widgetsDottedStat2['default'], { number: props.player.titlesByTournamentId[props.tournament.id], text: titlesText }),
    _react2['default'].createElement(_widgetsDottedStat2['default'], { number: props.player.tripleCrownTitles, text: tripleCrownTitlesText })
  );
};

exports.PlayerCard = PlayerCard;
var Team = function Team(props) {
  var teamStyle = _extends({}, _browserVendorPrefix.alignItemsCenter, {
    textAlign: 'center',
    width: '25%'
  });

  return _react2['default'].createElement(
    _panelsUi.Panel,
    { width: props.width, style: style.panel },
    _react2['default'].createElement(
      'h1',
      { style: style.title },
      _react2['default'].createElement(
        'span',
        null,
        props.tournament.name + ' ' + props.group.name
      ),
      _react2['default'].createElement(
        'span',
        null,
        props.team.name
      )
    ),
    _react2['default'].createElement(_widgetsSponsor2['default'], _extends({}, props.sponsor, { colour: 'BLUE', style: style.sponsor })),
    _react2['default'].createElement(
      'div',
      { style: style.stats },
      _react2['default'].createElement(
        'div',
        { style: teamStyle },
        _react2['default'].createElement('img', { src: '/teams/' + props.team.id + '/logo.svg', alt: props.team.name, style: style.teamLogo }),
        _react2['default'].createElement(
          'span',
          { style: style.text },
          props.team.name
        )
      ),
      _react2['default'].createElement(_widgetsStat2['default'], { number: props.team.handicap, text: 'Handicap', style: style.stat }),
      _react2['default'].createElement(_widgetsStat2['default'], { number: props.team.titlesByTournamentId[props.tournamentId], text: 'Títulos en ' + props.tournament.name, style: style.stat }),
      _react2['default'].createElement(_widgetsStat2['default'], { number: props.team.tripleCrownTitles, text: 'Títulos de la Triple Corona', style: style.stat })
    ),
    _react2['default'].createElement(
      'div',
      { style: style.players },
      props.team.players.map(function (player, i) {
        return _react2['default'].createElement(PlayerCard, { colour: props.team.colour, player: props.playersById[player], key: i,
          i: i, tournament: props.tournament });
      })
    )
  );
};

exports.Team = Team;
var style = {
  team: _extends({}, _browserVendorPrefix.flexDirectionRow, {
    fontSize: 30,
    marginTop: 75,
    textTransform: 'uppercase'
  }),
  panel: {
    backgroundColor: _style.WHITE,
    color: _style.BLUE,
    fontFamily: _style.FONT,
    fontWeight: _style.FONT_LIGHT,
    paddingLeft: 35,
    paddingRight: 35,
    paddingBottom: 200
  },
  player: {
    marginTop: 25
  },
  playerContent: _extends({}, _browserVendorPrefix.alignItemsCenter, _browserVendorPrefix.flexDirectionRow),
  playerHeading: _extends({}, _browserVendorPrefix.flexDirectionRow, {
    textTransform: 'uppercase'
  }),
  playerName: {
    marginLeft: 10
  },
  playerNumber: {
    fontWeight: 600
  },
  playerPhoto: {
    height: 100,
    width: 100
  },
  players: {
    marginTop: 25
  },
  title: {
    fontSize: 20,
    fontWeight: _style.FONT_LIGHT,
    marginTop: 85,
    textTransform: 'uppercase'
  },
  sponsor: {
    marginTop: 25
  },
  stats: _extends({}, _browserVendorPrefix.flexDirectionRow, _browserVendorPrefix.justifyContentSpaceBetween, {
    marginTop: 75
  }),
  stat: {
    width: '25%'
  },
  teamLogo: {
    height: 89,
    width: '100%'
  }
};

function mapStateToProps(state, props) {
  var group = state.tournaments.groupsById[_groupGetGroupId2['default'](props.tournamentId, props.groupRef)];

  return {
    club: state.tournaments.clubsById[props.tournamentId],
    group: group,
    playersById: state.teams.playersById,
    sponsor: state.tournaments.sponsorsById[group.sponsorId],
    team: state.teams.byId[props.teamId],
    tournament: state.tournaments.byId[props.tournamentId]
  };
}

exports['default'] = _reactRedux.connect(mapStateToProps)(Team);